import './Experiencia.css';

const Experiencia = () => {
    const experiencias = [
        {
            cargo: 'Engenheiro de Software',
            empresa: 'Cox Automotive Brasil',
            periodo: '2024 - Presente',
            itens: [
                'Desenvolvimento e manutencao de aplicacoes corporativas com React, Next.js, TypeScript, APIs REST e servicos cloud.',
                'Concepcao e criacao de projetos completos e escalaveis com impacto direto em milhares de usuarios.',
                'Implementacao de integracoes entre front-end, APIs e camadas de dados, incluindo fluxos assincronos e tratamento de erros.',
                'Evolucao de design system corporativo com componentes reutilizaveis, padronizacao visual e testes automatizados.',
                'Otimizacao de builds, pipelines de validacao e deploy, melhorando a previsibilidade das entregas e reduzindo falhas de publicacao.',
                'Implementacao de seguranca e padronizacao de codigo com lint, Husky, Prettier, code review e validacoes automatizadas em pipeline.',
                'Troubleshooting de builds, deploys, permissoes, variaveis de ambiente, AWS S3, CloudFront, Lambda, EC2, IAM e CodeBuild.',
                'Colaboracao com produto, UX/UI, QA e DevOps em refinamentos, code reviews e entregas continuas.'
            ]
        },
        {
            cargo: 'Desenvolvedor Freelancer',
            empresa: 'Projetos web',
            periodo: '2021 - 2023',
            itens: [
                'Criacao de aplicacoes responsivas com React, JavaScript, HTML5, CSS3, Python e integracoes com APIs.',
                'Implementacao de funcionalidades fullstack, scripts de automacao, ajustes visuais, deploy e manutencao.',
                'Modelagem simples de dados, consumo de endpoints, validacoes e organizacao de codigo para clientes.'
            ]
        }
    ];

    const destaques = [
        'Frontend com React, Next.js, Vite, Turbopack, Webpack, Storybook e bibliotecas de componentes.',
        'Backend e APIs com Node.js, Python, C#/.NET, SQL, REST APIs, integracoes, manutencao, validacoes e fluxos assincronos.',
        'Arquitetura web com micro frontends, static export, build optimization, cache/CDN e comunicacao entre camadas.',
        'DevEx e seguranca de codigo com ESLint, Husky, Prettier, pipelines de validacao, padroes de commit e automacoes pre-merge.',
        'Cloud e DevOps com AWS S3, CloudFront, Lambda, EC2, ECS, IAM, CodeBuild, CI/CD, GitHub Actions e otimizacao de pipelines.',
        'Qualidade com Jest, React Testing Library, Cypress, code review, testes automatizados e quality gates.',
        'Vivencia com Scrum, Kanban, times multidisciplinares e resolucao de incidentes em producao.'
    ];

    return (
        <section id="experiencia" className="experiencia">
            <h1>Experiencia</h1>
            <div className="experienciaGrid">
                <div>
                    {experiencias.map((experiencia) => (
                        <article className="experienciaCard" key={`${experiencia.cargo}-${experiencia.empresa}`}>
                            <span>{experiencia.periodo}</span>
                            <h2>{experiencia.cargo}</h2>
                            <h3>{experiencia.empresa}</h3>
                            <ul>
                                {experiencia.itens.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
                <aside className="destaques">
                    <h2>Destaques tecnicos</h2>
                    <ul>
                        {destaques.map((destaque) => (
                            <li key={destaque}>{destaque}</li>
                        ))}
                    </ul>
                </aside>
            </div>
        </section>
    );
};

export default Experiencia;
